export default __webpack_public_path__ + "static/firstSection-7ded3d5be513e58572dc10a9e37512a8.png";